/* RESPONSIBLE TEAM: team-workflows */
import BaseValidator from 'ember-cp-validations/validators/base';
import { inject as service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { STANDALONE_CHANNELS } from 'embercom/lib/operator/custom-bots/constants';

const TriggerWorkflowChannelCompatibility = BaseValidator.extend({
  intl: service(),
  appService: service(),

  validate(_stepType, _options, model) {
    let compatibleChannels = model.compatibleChannels;
    let targetChannels = model.editorConfig?.targetChannels || model?.targetChannels;

    if (isEmpty(targetChannels)) {
      return true; // Skip this validator until we can get the target channels
    }

    // Don't try to validate against Standalone channels when not in a standalone app
    if (!this.appService.app.isStandaloneApp) {
      targetChannels = targetChannels.filter((channel) => {
        return !STANDALONE_CHANNELS.includes(channel);
      });
    }

    if (isEmpty(compatibleChannels)) {
      return false; // TODO: Add an error message for this case
    }

    let unsupportedChannels = targetChannels.filter(
      (channel) => !compatibleChannels.includes(channel),
    );

    if (!isEmpty(unsupportedChannels)) {
      return this.intl.t(
        'operator.workflows.visual-builder.validations.trigger-workflow-not-supported-by-channel',
        {
          channels: this.intl.formatList(unsupportedChannels, {
            style: 'long',
            type: 'conjunction',
          }),
        },
      );
    } else {
      return true;
    }
  },
});

TriggerWorkflowChannelCompatibility.reopenClass({
  getDependentsFor() {
    return ['model.compatibleChannels', 'model.editorConfig', 'model.editorConfig.targetChannels'];
  },
});

export default TriggerWorkflowChannelCompatibility;
